export default {
    gateways: {
        metaList: [],
        list: [],
        rowsNumber: 10,
        gateway_apis: [
            {id: "telynx", name: "Telynx", canSchedule: false},
            {id: "nexmo", name: "Nexmo", canSchedule: false},
            {id: "twilio", name: "Twilio SMS", canSchedule: true},
            {id: "afrikastalking", name: "Afrika's Talking", canSchedule: false},
        ],
    }
}
